"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = exports.sizes = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var styles_1 = require("@material-ui/core/styles");
exports.sizes = {
    small: 18,
    medium: 24,
    large: 36,
};
exports.useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        '@keyframes spin': {
            from: {
                transform: 'rotate(0deg)',
            },
            to: {
                transform: 'rotate(360deg)',
            },
        },
        spin: {
            animation: '$spin infinite 3s linear',
        },
    });
});
var LoadingIndicator = function (_a) {
    var classNameProp = _a.className, _b = _a.size, sizeProp = _b === void 0 ? 'medium' : _b, other = __rest(_a, ["className", "size"]);
    var classes = exports.useStyles();
    var size = sizeProp;
    if (typeof size === 'string' && Object.keys(exports.sizes).includes(size)) {
        size = exports.sizes[size];
    }
    return (react_1.default.createElement("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: clsx_1.default(classes.spin, classNameProp), "aria-label": "Loading" }, other),
        react_1.default.createElement("line", { x1: "12", y1: "2", x2: "12", y2: "6" }),
        react_1.default.createElement("line", { x1: "12", y1: "18", x2: "12", y2: "22" }),
        react_1.default.createElement("line", { x1: "4.93", y1: "4.93", x2: "7.76", y2: "7.76" }),
        react_1.default.createElement("line", { x1: "16.24", y1: "16.24", x2: "19.07", y2: "19.07" }),
        react_1.default.createElement("line", { x1: "2", y1: "12", x2: "6", y2: "12" }),
        react_1.default.createElement("line", { x1: "18", y1: "12", x2: "22", y2: "12" }),
        react_1.default.createElement("line", { x1: "4.93", y1: "19.07", x2: "7.76", y2: "16.24" }),
        react_1.default.createElement("line", { x1: "16.24", y1: "7.76", x2: "19.07", y2: "4.93" })));
};
exports.default = LoadingIndicator;
//# sourceMappingURL=LoadingIndicator.js.map